__webpack_require__.p = "https://qa.uk.knowledgesearchadmin.thomsonreuters.com/";